import { render } from "./ChildTweets.vue?vue&type=template&id=9649a0ce&scoped=true"
import script from "./ChildTweets.vue?vue&type=script&lang=js"
export * from "./ChildTweets.vue?vue&type=script&lang=js"

import "./ChildTweets.vue?vue&type=style&index=0&id=9649a0ce&lang=scss&scoped=true"

import exportComponent from "/Users/parasagrawal/projects/twitter-helpdesk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9649a0ce"]])

export default __exports__